export default __webpack_public_path__ + "static/media/Plode Icon.ac53e4a2.png";